import { render, staticRenderFns } from "./updateAdmin.vue?vue&type=template&id=c3e8db76"
import script from "./updateAdmin.vue?vue&type=script&lang=js"
export * from "./updateAdmin.vue?vue&type=script&lang=js"
import style0 from "./updateAdmin.vue?vue&type=style&index=0&id=c3e8db76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports